import React from "react";
import Header from "./components/header";
import Footer from "./components/footer";
import Main from "./components/main";
import Json from './json/products.json';
import Categories from "./components/categories";
import ShowFullItem from "./components/showFullItem";

class App extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      orders: [],
      currentItems: [],
      items:[...Json],
      showFullItem: false,
      fullItem: {}
    }
    this.state.currentItems = this.state.items;
    this.addToOrder = this.addToOrder.bind(this);
    this.deleteOrder = this.deleteOrder.bind(this);
    this.chooseCategory = this.chooseCategory.bind(this);
    this.onShowItem = this.onShowItem.bind(this);
  }
  render(){
    return (
      <div>
        <div className="wrapper">
          <Header orders={this.state.orders} onDelete={this.deleteOrder}/>
          <Categories chooseCategory={this.chooseCategory}/>
          <Main items={this.state.currentItems} onAdd={this.addToOrder} onShowItem={this.onShowItem}/>
        </div>
        {this.state.showFullItem && <ShowFullItem onAdd={this.addToOrder} onShowItem={this.onShowItem} item={this.state.fullItem}/>}
        <Footer />
      </div>
    )
  }
  addToOrder(item) {
    let isInArray = false;
    this.state.orders.forEach(el => {
      if(el.id === item.id){
        isInArray = true;
      }
    })
      if(!isInArray){
        this.setState({orders: [...this.state.orders, item] });
      }
  }
  deleteOrder(id){
    this.setState({orders: this.state.orders.filter((elem)=>{
      return elem.id !== id;
    })})
  }
  chooseCategory(category){
    if(category === 'all'){
      this.setState({ currentItems: this.state.items });
      return;
    }

    this.setState({
      currentItems: this.state.items.filter((el)=>{
          return el.category === category;
      })
    })

  }
  onShowItem(item){
    this.setState({fullItem: item});
    this.setState({ showFullItem: !this.state.showFullItem});

  }
}
export default App;